export interface HasClassName {
  className?: string;
}

export enum ResourceLoadingStatus {
  NONE,
  PENDING,
  COMPLETE,
}
